<template>
  <div>
    <vx-breadcrumb
      :list="breadcrumbList"
      @breadcrumb-click="handleBreadcrumbNavigation"
      class="custom-bread-crumb"
    />
    <vx-card class="mb-base">
      <div class="vx-row">
        <div class="vx-col md:w-full lg:w-full w-full">
          <ul class="horizontal-sm-btn flex mb-2 float-right">
            <li>
              <div
                class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
              >
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-download"
                  class="truncate"
                  size="small"
                  @click="downloadStatement"
                  >{{ $t("customers.label.download") }}</vs-button
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="vx-row">
        <vx-card no-shadow>
          <div class="vx-row mb-4">
            <div class="vx-col md:w-1/2 lg:w-1/2 w-full">
              <strong class="mr-3">{{ $t("customers.label.due_date") }}</strong>
              :&nbsp;&nbsp;
              <label>{{ getDate(getBillDetail.dueDate) }}</label>
            </div>
            <div class="vx-col md:w-1/2 lg:w-1/2 w-full">
              <strong class="mr-3">{{
                $t("customers.label.due_amount")
              }}</strong>
              :&nbsp;&nbsp;
              <label v-if="getBillDetail.dueAmount">{{ getBillDetail.dueAmount }}</label>
              <label v-else>0</label>
            </div>
          </div>
          <hr />
          <h5 class="my-3">{{ $t("customers.label.transactions") }}</h5>

          <vs-table stripe :data="getBillDetail" class="details-table w-full">
            <template slot="thead">
              <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.amount") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(viewBill, index) in data">
                <vs-td :data="viewBill.transaction">{{
                  viewBill.transaction
                }}</vs-td>

                <vs-td :data="viewBill.amount">{{ viewBill.amount }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </vx-card>
  </div>
</template>
<script>
import moment from "moment";
import { BUCKET_BASE_URL } from "@/http/index";
export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.customerId}`,
        },
        { name: "View Statement" },
      ],
      billId: "",
    };
  },
  computed: {
    getBillDetail() {
      return this.$store.getters["customerAccount/getBillDetailData"];
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    async billMaster() {
      try {
        this.$store.dispatch("customerAccount/setViewBillDetail", this.billId);
      } catch (e) {
        console.log(
          "Something went wrong while retrieving client bill master: ",
          e
        );
      }
    },
    downloadStatement() {
      window.open(
        BUCKET_BASE_URL + `/billmaster/${this.billId}/print?tenantIdentifier=default`
      );
    },
  },
  mounted() {
    this.billId = this.$route.params.id;
    this.billMaster();
  },
};
</script>
<style lang="scss" scoped></style>
